import { render, staticRenderFns } from "./IcoPaperPlane.vue?vue&type=template&id=f72ebcfc"
import script from "./IcoPaperPlane.vue?vue&type=script&lang=js"
export * from "./IcoPaperPlane.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports